import { WEI_XIN_PATH } from 'src/constants'

const { VUE_APP_BASE_CDN, VUE_APP_BASE_NAME, VUE_APP_UPLOADED_URL, VUE_APP_ENV } = process.env

// fe 设计图片
export const cdnURL = name => `${VUE_APP_BASE_CDN}/${VUE_APP_BASE_NAME}/images/${name}`

// 通用图片
export const commonURL = name => `${VUE_APP_BASE_CDN}/common/images/${name}`

// 业务图片
export const businessURL = key => `${VUE_APP_UPLOADED_URL}/${key}`

/**
 * location.search 转为k-v对象
 * @return {{}}
 */
export function qs () {
  const search = location.search.slice(1)
  const res = {}
  try {
    search.split('&').forEach(i => {
      const kv = i.split('=')
      res[kv[0]] = kv[1]
    })
  } catch (e) {
    console.log(e)
  }
  return res
}

export const baseJumpUrl = {
  dev: 'https://d-base.kkkf.cn/',
  test: 'https://t-base.kkkf.cn/',
  production: 'https://base.kkkf.cn/'
}[VUE_APP_ENV]

export const healthJumpUrl = {
  dev: 'https://d-health.kkkf.cn/',
  test: 'https://t-health.kkkf.cn/',
  production: 'https://patient.kkkf.cn/'
}[VUE_APP_ENV]

/**
 * 一维query对象的转换
 * @param query
 * @returns {string}
 */
export function plantQs (query) {
  if (!Object.keys(query).length) {
    return ''
  }
  try {
    return (
      '?' +
      Object.keys(query)
        .map(i => i + '=' + query[i])
        .join('&')
    )
  } catch (e) {
    return ''
  }
}

/**
 * 转换成url
 * @param domain
 * @param path
 * @param query
 * @returns {*}
 */
export function formatUrl ({ domain, path, query }) {
  return domain + path.replace(/^\/+/, '') + plantQs(query)
}

/**
 * 对url进行容错
 * @param path1 路径1
 * @param path2 路径2
 * @returns {string} https://a.com/b/c 或者 /service/a/b/c
 * @source https://github.com/axios/axios/blob/master/lib/helpers/combineURLs.js
 */
export const formatURL = (path1, path2) => path1.replace(/\/+$/, '') + '/' + path2.replace(/^\/+/, '')

/**
 *
 * @param {1 | 2 | 3 | number} app 公众号id（1: 甲状腺公众号，2：壹宝之家，3：17健康，默认3）
 * @param { 'other' | 'form' | 'page' | 'article' | 'formPreview' } pageType 跳转页面类型
 * @param {string} path
 * @param {Object} query
 */
export function getClientUrl ({
  app = 3,
  pageType = 'other',
  path = '',
  query = {}
}) {
  if (app) {
    query.app = app
  }
  const url = pageType === 'rxa-other' ? process.env.VUE_APP_RXA_H5_HEALTH.slice(0, -1) : process.env.VUE_APP_ACCOUNT_DOMAIN
  return formatURL(url + WEI_XIN_PATH[pageType], path + plantQs(query))
}
